// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import media from '../../styles/media'
import colors from '../../styles/colors'
import { createClient } from '../../actions/forms'
import PageHeader from '../../components/PageHeader'
import Card from '../../components/Card'
import HireForm from './components/HireForm'
import VirtualTours from '../../components/VirtualTours'

const PackageCard = styled.div`
  padding: 50px 20px;
  margin: 2rem auto;
  background: #fff;
  box-shadow: 0 5px 21px rgba(20, 33, 47, 0.13), inset 4px 4px ${colors.primary},
    inset -4px -4px ${colors.primary};
  width: 100%;
  ${media.mdUp} {
    width: 400px;
  }
`

const PackageOverview = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`

// const Price = styled.span`
//   display: block;
//   font-weight: bold;
//   font-size: 30px;
//   line-height: 1;

//   ${media.mdUp} {
//     font-size: 50px;
//   }
// `

// const Commission = styled.span`
//   font-weight: 300;
//   font-size: 20px;
// `

const Header = styled.h3`
  margin-bottom: 1rem;
`

const Lead = styled.p`
  font-size: 20px;
  font-weight: 300;
`

const Item = styled.p`
  margin-bottom: 0.5rem;
`

type Props = {
  createClient: Function
}

class HireUs extends Component {
  props: Props

  handleSubmit = (data) => this.props.createClient(data)

  render() {
    return (
      <div>
        <Helmet title="Hire Us" />
        <PageHeader text="Hiring Us Is Simple">
          Explore the components of our full-service suite shown below. We offer
          to include professional photography and a Matterport 3D virtual tour
          with all of our property listings.{' '}
          <b>Check out the 3D experience in one of our sample tours below!</b>
        </PageHeader>
        <VirtualTours />
        <div className="container">
          <PackageCard>
            <PackageOverview>
              <Header>Full-Service Brokerage</Header>
              <Lead>Small Town Service, Big City Results</Lead>
              {/* <Price>6.5%</Price>
              <Commission>total commission</Commission> */}
            </PackageOverview>
            <hr />
            <Item>
              <b>Experienced</b> representation and guidance
            </Item>
            <Item>
              <b>Dedicated</b> client care associate
            </Item>
            <Item>
              <b>No-hassle</b> listing contract agreements
            </Item>
            <hr />
            <Item>
              <b>Entered</b> in MRED MLS system
            </Item>
            <Item>
              <b>Posted</b> on Realtor.com, Zillow and Trulia
            </Item>
            <Item>
              <b>Custom</b> property webpage and domain
            </Item>
            <Item>
              <b>Social Media</b> non-paid announcements
            </Item>
            <Item>
              <b>Web traffic</b> statistics tracking
            </Item>
            <Item>
              <b>Matterport</b> 3D virtual tour
            </Item>
            <Item>
              <b>Custom</b> video promotion
            </Item>
            <Item>
              <b>Virtual tour</b> open houses
            </Item>
            <Item>
              <b>Facebook</b> ads paid campaign
            </Item>
            <Item>
              <b>Always exploring</b> other online ad medias
            </Item>
          </PackageCard>
          <Card style={{ marginBottom: '6rem' }}>
            <p style={{ fontSize: '1.25rem', fontWeight: '300' }}>
              Please fill out the form below to get started working with us. If
              you have questions about our marketing or services, we can discuss
              them in our initial meeting.
            </p>
            <hr style={{ margin: '2rem 0' }} />
            <HireForm onSubmit={this.handleSubmit} />
          </Card>
        </div>
      </div>
    )
  }
}

export default connect(
  null,
  { createClient }
)(HireUs)



// WEBPACK FOOTER //
// ./src/views/HireUs/index.js